jQuery(document).ready(function($) {
"use strict";
$('#review_container').owlCarousel( {
		loop: true,
		center: true,
		items: 3,
		margin: 30,
		autoplay: true,
  autoHeight: true,
		dots: true,
    nav:true,
		autoplayTimeout: 5000,
		smartSpeed: 450,
  	navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
		responsive: {
			0: {
				items: 1
			},
			768: {
				items: 2
			},
			1170: {
				items: 3
			}
		}
	});

  $('.feedback_item .cta_wrap').on('click', function(){
    $('.review_slider .popup .container').empty();
    $('.review_slider .popup .container').append($(this).parent('.feedback_item').clone());
$('.review_slider .popup').show();
    $('body').css('overflow','hidden');
  });

    $('.popup').on('click', function(e){
      $('body').css('overflow','auto');
      $(this).hide();
    });
$('.container').on('click',function(e){
    e.stopPropagation(); 
});
  
});